import { FILTERS_BASE_CLASS } from "../constants.js";

export default class LocationSearchFilters {
  constructor(container, store, eventBus) {
    this.container = container;
    this.store = store;
    this.eventBus = eventBus;

    this.typeFilterElements = this.container
      ? this.container.querySelectorAll(`.${FILTERS_BASE_CLASS}__event-type`)
      : [];

    this.addEventListeners();
    this.addButtonClickHandlers();
    this.autoSelectSingleFilter();
    this.render();
  }

  addEventListeners() {
    this.eventBus.on("locationTypeFiltersChanged", this.render.bind(this));
  }

  addButtonClickHandlers() {
    this.typeFilterElements.forEach((filter) => {
      filter.addEventListener("click", this.handleFilterClick.bind(this, filter));
    });
  }

  autoSelectSingleFilter() {
    console.log("Auto-selecting single filter if applicable");
    console.log(this.typeFilterElements);
    if (this.typeFilterElements.length === 1) {
      const singleFilter = this.typeFilterElements[0];
      const typeValue = singleFilter.dataset.value;
      this.store.setActiveTypeValue(typeValue);
    }
  }

  handleFilterClick(filter) {
    const typeValue = filter.dataset.value;
    this.store.setActiveTypeValue(typeValue);
    this.scrollToSlider();
    this.render();
  }

  scrollToSlider() {
    const sliderContainer = document.querySelector(".location-search-slider");
    if (sliderContainer) {
      const headerHeight = document.querySelector("header")?.offsetHeight || 0;
      const offset = 150;
      const scrollTargetY =
        sliderContainer.getBoundingClientRect().top + window.scrollY - headerHeight - offset;
      window.scrollTo({ top: scrollTargetY, behavior: "smooth" });
    }
  }

  render() {
    const activeType = this.store.activeTypeValue;
    this.typeFilterElements.forEach((el) => {
      const isActive = el.dataset.value === activeType;
      el.classList.toggle("btn-primary", isActive);
      el.classList.toggle("location-search-filters__event-type--active", isActive);
      // el.classList.toggle("btn-outline-gray-100", !isActive);
    });
  }
}